import { defineStore } from 'pinia';
import { f7 } from 'framework7-vue';
import { useKeycloakStore } from './keycloak.js';

const delivery_path = import.meta.env.VITE_APP_URLITE_APP_URL + 'delivery';
const pickup_path = import.meta.env.VITE_APP_URLITE_APP_URL + 'pickup';

export const useDeliveryStore = defineStore('delivery', {
  state: () => ({
    deliveryAccount: '',
    delivery: '',
    deliverer: '',
    pickuPointAccount: '',
    pickuPoint: '',
  }),
  persist: true,

  actions: {
    async createDeliveryAccount(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: deliveryAccount } = await axios({
          url: `${delivery_path}/create/account`,
          method: 'POST',
          data: payload,
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.deliveryAccount = deliveryAccount;
        f7.views.main.router.navigate(`/delivery/${deliveryAccount.id}`);
      } catch (err) {
        console.log(err);
      }
    },

    async editDeliveryAccount(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: deliveryAccount } = await axios({
          url: `${delivery_path}/edit/account`,
          method: 'PUT',
          data: payload,
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.deliveryAccount = deliveryAccount;
      } catch (err) {
        console.log(err);
      }
    },

    async getDeliveryAccount() {
      const { default: axios } = await import('axios');
      try {
        const { data: deliveryAccount } = await axios({
          url: `${delivery_path}/account`,
          method: 'GET',
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.deliveryAccount = deliveryAccount;
      } catch (err) {
        console.log(err);
      }
    },

    async addDeliverer(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: deliveryAccount } = await axios({
          url: `${delivery_path}/add/deliverer`,
          method: 'POST',
          data: payload.deliverer,
          params: { deliveryAccountId: payload.deliveryAccountId },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.deliveryAccount = deliveryAccount;
      } catch (err) {
        console.log(err);
      }
    },

    async removeDeliverer(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: deliveryAccount } = await axios({
          url: `${delivery_path}/remove/deliverer`,
          method: 'PUT',
          params: {
            deliveryAccountId: payload.deliveryAccountId,
            delivererId: payload.delivererId,
          },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.deliveryAccount = deliveryAccount;
      } catch (err) {
        console.log(err);
      }
    },

    async createPickupPointAccount(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: pickuPointAccount } = await axios({
          url: `${pickup_path}/create/account`,
          method: 'POST',
          data: payload,
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.pickuPointAccount = pickuPointAccount;
        f7.views.main.router.navigate(`/pickup/${pickuPointAccount.id}`);
      } catch (err) {
        console.log(err);
      }
    },

    async editPickupAccount(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: pickuPointAccount } = await axios({
          url: `${pickup_path}/edit/pickupAccount`,
          method: 'PUT',
          data: payload,
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.pickuPointAccount = pickuPointAccount;
      } catch (err) {
        console.log(err);
      }
    },

    async getPickupAccount() {
      const { default: axios } = await import('axios');
      try {
        const { data: pickuPointAccount } = await axios({
          url: `${pickup_path}/pickupAccount`,
          method: 'GET',
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.pickuPointAccount = pickuPointAccount;
      } catch (err) {
        console.log(err);
      }
    },

    async addPickupPoint(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: pickuPointAccount } = await axios({
          url: `${pickup_path}/add/pickupPoint`,
          method: 'POST',
          data: payload.pickupPoint,
          params: { pickupPointAccountId: payload.pickupPointAccountId },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.pickuPointAccount = pickuPointAccount;
      } catch (err) {
        console.log(err);
      }
    },

    async editPickupPoint(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: pickuPointAccount } = await axios({
          url: `${pickup_path}/edit/pickupPoint`,
          method: 'PUT',
          data: payload.pickupPoint,
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.pickuPointAccount = pickuPointAccount;
      } catch (err) {
        console.log(err);
      }
    },

    async removePickupPoint(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: pickuPointAccount } = await axios({
          url: `${pickup_path}/remove/pickupPoint`,
          method: 'PUT',
          params: {
            pickupPointAccountId: payload.pickupPointAccountId,
            pickupPointId: payload.pickupPointId,
          },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.pickuPointAccount = pickuPointAccount;
      } catch (err) {
        console.log(err);
      }
    },

    async createDelivery(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: delivery } = await axios({
          url: `${delivery_path}/create/delivery`,
          method: 'POST',
          data: payload.delivery,
          params: {
            shopOrderId: payload.shopOrderId,
            delivererAcctId: payload.delivererAcctId,
            delivererId: payload.delivererId,
          },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.delivery = delivery;
      } catch (err) {
        console.log(err);
      }
    },

    async editDelivery(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: delivery } = await axios({
          url: `${delivery_path}/edit/delivery`,
          method: 'PUT',
          params: {
            orderStatus: payload.orderStatus,
            deliveryId: payload.deliveryId,
            delivererId: payload.delivererId,
            deliveryAmt: payload.deliveryAmt,
          },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.delivery = delivery;
      } catch (err) {
        console.log(err);
      }
    },

    async updateDeliveryStatus(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data: delivery } = await axios({
          url: `${delivery_path}/update/status`,
          method: 'PUT',
          params: {
            orderStatus: payload.orderStatus,
            deliveryId: payload.deliveryId,
          },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.delivery = delivery;
      } catch (err) {
        console.log(err);
      }
    },
  },
});
